import { PASSWORD_REQUIREMENTS } from "../constants/password"

export const getPasswordErrorMessage = requirementType => {
  const requirement = PASSWORD_REQUIREMENTS.find(
    requirement => requirement.type === requirementType
  )

  return requirement ? requirement.description : ""
}
